export default __webpack_public_path__ + "static/media/account.c2b0511f.svg";